import React, { useEffect, useRef, memo, useState } from 'react';

function TradingViewWidget() {
    const container = useRef();
    const scriptId = "tradingview-widget-script"; // Unique ID for the script element

    useEffect(() => {
        // Check if the script is already added
        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            script.id = scriptId; // Assign the unique ID
            script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
            script.type = "text/javascript";
            script.async = true;
            script.innerHTML = `
            {
              "height": "400",
              "autosize": true,
              "symbol": "MEXC:ALPHUSDT",
              "timezone": "Etc/UTC",
              "theme": "dark",
              "style": "1",
              "locale": "en",
              "range": "12M",
              "withdateranges": true,
              "hide_side_toolbar": false,
              "allow_symbol_change": false,
              "show_popup_button": true,
              "calendar": false,
              "support_host": "https://www.tradingview.com"
            }`;
            container.current.appendChild(script);
        }
    }, []);

    return (
        <div className="tradingview-widget-container" ref={container} style={{ height: "400px", width: "100%" }}>
            <div className="tradingview-widget-container__widget" style={{ height: "calc(100% - 32px)", width: "100%" }}></div>
        </div>
    );
}

export default memo(TradingViewWidget);
